import { FieldConfirmationTypeEnums } from '@/enums/FieldConfirmationTypeEnums';
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class ConfirmationCardComponent extends Vue {
    @PropSync('modal', { type: Boolean }) public showModal!: boolean;
    @PropSync('modalAction', { type: String }) public header!: string;
    @PropSync('modalBody', { type: String }) public body!: string;
    @PropSync('from', { type: String }) public confirmationFrom!: string;
    @PropSync('type', { type: Number }) public inType!: FieldConfirmationTypeEnums;

    public usedType: FieldConfirmationTypeEnums = FieldConfirmationTypeEnums.Unknown;
    public types = FieldConfirmationTypeEnums;

    @Watch('inType', { immediate: true })
    public inTypeChanged(newValue: FieldConfirmationTypeEnums) {
        this.usedType = newValue;
    }

    @Watch('confirmationFrom', { immediate: true })
    public inFromChanged(newValue: string) {
        if (newValue != null) {
            if (newValue === 'Save') {
                this.usedType = FieldConfirmationTypeEnums.Save;
            } else if (newValue === 'EmptyFilter') {
                this.usedType = FieldConfirmationTypeEnums.EmptyFilter;
            } else {
                this.usedType = FieldConfirmationTypeEnums.Unknown;
            }
        }
    }
}
